"use client"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { FC, useEffect, useState } from "react"
import { useRefresh, useUpdate } from "react-admin"
import { toast } from "sonner"
import { LockKeyholeOpen } from "lucide-react"

interface Props {
    id: number;
    title: string;
    description?: string;
}

const UnauthorizeDevice: FC<Props> = ({ id, title, description }) => {

    const refresh = useRefresh()
    const [update] = useUpdate();
    const [open, setOpen] = useState(false)

    const handleDeleteClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        setOpen(true)
    }

    const confirm = async () => {
        update(`devices/${id}/authorize`, { id: "", data: { authorized: false } }).then(() => {
            setTimeout(() => {
                toast("Device Unauthorized", {
                    description: "The device has been unauthorized."
                })
                refresh();
            }, 500);
        })
        setOpen(false);
    }

    return (
        <>
            <DropdownMenuItem onClick={handleDeleteClick}>
                <LockKeyholeOpen className="mr-2 h-4 w-4 text-destructive" />
                {title}
            </DropdownMenuItem>
            <AlertDialog open={open} onOpenChange={setOpen}>
                <AlertDialogContent>
                    <AlertDialogHeader>
                        <AlertDialogTitle>Are you sure you want to unauthorize this device?</AlertDialogTitle>
                        <AlertDialogDescription>
                            {description || "This action can not be undone."}
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel onClick={() => setOpen(false)}>Cancel</AlertDialogCancel>
                        <Button variant="destructive" onClick={confirm}>
                            Confirm
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    )
}
export default UnauthorizeDevice